import React from "react";
import {
  Instagram,
  Twitter,
  Facebook,
  Youtube,
  Tiktok,
} from "../../assets/SvgIcons";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <div className="contact-section" id="Contacts">
      <h1>{t("Contacts")}</h1>
      <div className="w-100 d-flex justify-content-between align-items-start contact-section-wrapper">
        <div className="contacts-items ">
          <h3>{t("Working hours")}</h3>
          <p>08:00 - 22:00, {t("7 days a week")}</p>
        </div>
        <div className="max-w-100 w-100 contacts-items ">
          <h3>{t("Address")}</h3>
          <p>{t("Kurinna 24, Dnipro Ukraine")}</p>
        </div>
        <div className=" contacts-items ">
          <h3>{t("Phone")}</h3>
          <p>+38 063 258 54 24</p>
        </div>
        <div className="contacts-items">
          <h3>{t("Social media")}</h3>
          <div className=" d-flex justify-content-start gap-3 py-2">
              <a href="https://www.instagram.com/rogersounds/" target="_blank" rel="noreferrer">
              <Instagram />
              </a>
              <a href="https://x.com/rogersounds" target="_blank" rel="noreferrer">
            <Twitter />
            </a>
            <a href="https://www.facebook.com/rogersoundsfb" target="_blank" rel="noreferrer">
            <Facebook />
            </a>
            <a href="https://www.youtube.com/@rogersounds" target="_blank" rel="noreferrer">
            <Youtube />
            </a>
            <a href="https://www.tiktok.com/@rogersoundstt" target="_blank" rel="noreferrer">
            <Tiktok />
            </a>
          </div>
        </div>
      </div>
      <div className="w-100 contact-map brd">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7824.1913053336675!2d34.951534579314526!3d48.48719386654412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40dbe22c9e085889%3A0xc37be081d2bdc9c1!2z0KHRgtGD0LTRltGPINCX0LLRg9C60L7Qt9Cw0L_QuNGB0YMgUm9nZXI!5e0!3m2!1sen!2sua!4v1726497256462!5m2!1sen!2sua"
          width="100%"
          height="462"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
